import Skeleton from './Skeleton';
import RowListSkeleton from './src/RowListSkeleton';
import TileSkeleton from './src/TileSkeleton';
import GridSkeleton from './src/GridSkeleton';

export default Skeleton;
export { RowListSkeleton, TileSkeleton, GridSkeleton };
